// import the library
import { library } from '@fortawesome/fontawesome-svg-core';

// import your icons
import {
  faHome,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faSnowflake,
  faSpinner,
  faBars,
  faCircle,
  faBuilding,
  faCompass,
  faHandshake,
  faProjectDiagram
} from '@fortawesome/free-solid-svg-icons';

// add to library
library.add(
  faHome,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faSnowflake,
  faSpinner,
  faBars,
  faCircle,
  faBuilding,
  faCompass,
  faHandshake,
  faProjectDiagram
);
